export const INTEGRATION_PROVIDER = 'tec_alliance'
